import {mobileVhFix} from './utils/mobile-vh-fix';
import {initAccordion} from './modules/accordion/init-accordion';
import {initHeader} from './modules/header/init-header';
import {initModals} from './modules/modal/init-modals';
import {initValidation} from './modules/validation/init-validation';
import {initQuestionnaire} from './modules/init-questionnaire';
import {initPhoneMask} from './modules/init-phone-mask';
import {initTabs} from './modules/tabs/init-tabs';
import {initMoreless} from './moreless/init-moreless';
import {initCompletedProjectsSlider} from './modules/slider/init-completed-projects-slider';
import {initIntroSlider} from './modules/slider/init-intro-slider';
import {cookieBannerHandler} from './modules/cookie-banner-handler';
// import {initLenis} from './modules/init-lenis';


window.addEventListener('DOMContentLoaded', () => {
  // Utils
  // ---------------------------------

  mobileVhFix();

  // Modules
  // ---------------------------------

  initModals();
  initValidation();
  initPhoneMask();
  initHeader();
  initCompletedProjectsSlider();
  initAccordion();
  initTabs();
  initIntroSlider();
  initQuestionnaire();
  initMoreless();
  cookieBannerHandler();
  // initLenis();


  
  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
